import { GroupedByBrandShelfTalkerCardData } from './grouped-by-brand-shelf-talker-card-data';

export class FireAndFlowerShelfTalkerCardData extends GroupedByBrandShelfTalkerCardData {}
